<div class="card" [msAutomation]="automationEventIds" [class.my-bets-card-epcot]="enableRedesignedBetCard">
    @if (betslip.isSingleBet) {
        @if (betslip.bets[0].betBuilderInfo === null) {
            <ms-my-bets-single-bet-card [betslip]="betslip" [myBetsListContext]="myBetsListContext" />
        } @else {
            <ms-my-bets-betbuilder-card [betslip]="betslip" [myBetsListContext]="myBetsListContext" />
        }
    } @else {
        <ms-my-bets-multi-bet-card
            [betslip]="betslip"
            [earlyPayoutError]="betslip.earlyPayout?.error"
            [myBetsListContext]="myBetsListContext"
            [enableFlash]="enableFlash" />
    }
    @if (enableRedesignedBetCard) {
        <ds-divider />
    } @else {
        <div class="mybets-card-divider"></div>
    }
    <ms-my-bets-betslip-summary [betslip]="betslip" [myBetsListContext]="myBetsListContext" (infoClicked)="toggleToolbar()" />
    @if ((betslip.usedRewardToken || showBetAndGet) && !myBetsListContext.isPrintView && enableRedesignedBetCard) {
        <ms-my-bets-used-reward-token-epcot [betslip]="betslip" [rewardTokenImage]="rewardTokenImage()" [tokenSignPost]="tokenSignPost" />
        <div class="spacer-small"></div>
    }
    @if (pendingPayoutInfoVisible$ | async) {
        <ms-my-bets-betslip-payout-info />
    }
    @if (showReBet) {
        <ms-re-bet [betslip]="betslip" (setFlash)="setFlash($event)" />
    }
    <ms-my-bets-earlypayout-container
        [betslip]="betslip"
        [myBetsListContext]="myBetsListContext"
        [shouldRefreshPosition]="isLast"
        (autoCashoutPopperTriggered)="autoCashoutPopperTriggered($event)" />
    @if (isCashoutWinningsTaxMessage) {
        <div class="cashout-tax-message">{{ getCashoutTaxMessage }}</div>
    }
    @if ((betslip.usedRewardToken || showBetAndGet) && !myBetsListContext.isPrintView && !enableRedesignedBetCard) {
        <div class="mybets-card-divider"></div>
        @if (isEpcotEnabled) {
            <ms-my-bets-used-reward-token-epcot [betslip]="betslip" [tokenSignPost]="tokenSignPost" />
        } @else {
            <ms-my-bets-used-reward-token [betslip]="betslip" />
        }
    }
    @if (!isEpcotEnabled && (signpostingAwardBanners.length > 0 || tokenSignPost)) {
        <div class="mybets-card-divider"></div>
        <ms-postbet-signposting [tokenSignPost]="tokenSignPost" [banners]="signpostingAwardBanners" />
    }
</div>

<ms-my-bets-toolbar #toolbar [betslip]="betslip" [myBetsListContext]="myBetsListContext" />
@if (showEmptySpace) {
    <div class="empty-space"></div>
}
@if (isBetInEditMode) {
    <ms-my-bets-editing-overlay />
}
